import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { ITooltipBehavior } from "../../../../documaker/domain/format/objects";

export interface ITooltipBehaviorPropertyEditable {
  tooltipBehavior(): IPropertyEditable<ITooltipBehavior>;
}

export function instanceOfITooltipBehaviorPropertyEditable(instance: any): instance is ITooltipBehaviorPropertyEditable {
  return instance
      && instance.tooltipBehavior
      && instanceOfIPropertyEditable<ITooltipBehavior>(instance.tooltipBehavior());
}
